export default __webpack_public_path__ + "media/titles/title_5_locale_nb-37dd3920.png";